/**
 * Returns true for open-banking return paths (Aiia callbacks, connect-bank outcomes).
 *
 * Used in two places:
 * - `_protected.beforeLoad` — skips the immediate redirect-to-logout guard so the
 *   user isn't violently logged out when they return from an external bank flow.
 * - `AuthRefreshDialog` — suppresses the activity-timer logout on these paths.
 */
export const isOpenBankingCallbackPath = (pathname: string): boolean => {
  // Payment open-banking return pages (bill, statement)
  if (
    pathname.includes('/callback') &&
    (pathname.startsWith('/bill-payment') ||
      pathname.startsWith('/statement-payment'))
  )
    return true;

  // Connect-bank return pages (present across bill-payment, statement-payment, home/service)
  if (
    pathname.includes('/connect-bank/callback') ||
    pathname.includes('/connect-bank/error') ||
    pathname.includes('/connect-bank/cancel')
  )
    return true;

  return false;
};
